import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { PrivacyPolicyComponent } from './privacy-policy-component';

export function PrivacyPolicyFactory() {
  return (
    <BaseLayoutFactory>
      <PrivacyPolicyComponent />
    </BaseLayoutFactory>
  );
}
